export default __webpack_public_path__ + "static/media/pic5.c525c140.jpg";